import type { BreakdownDim, DateRange, EventType } from './types';

// Centralised TanStack Query keys. Importing from one place keeps invalidations
// honest — when you change a key here, all callers move together.
export const queryKeys = {
  me: ['me'] as const,
  apps: ['apps'] as const,
  campaigns: (status: string = 'active') => ['campaigns', status] as const,
  campaignSparklines: (status: string, days: number) =>
    ['campaigns', 'sparklines', status, days] as const,
  keys: ['keys'] as const,
  campaignStats: (id: number | string) => ['campaigns', id, 'stats'] as const,

  // Stats — analytics queries are keyed by their full input so React Query
  // dedupes naturally and date-range changes refetch.
  campaignTimeline: (id: number, r: DateRange) =>
    ['campaigns', id, 'timeline', r] as const,
  campaignBreakdown: (id: number, dim: BreakdownDim, type: EventType, r: DateRange) =>
    ['campaigns', id, 'breakdown', dim, type, r] as const,
  campaignHeatmap: (id: number, type: EventType, r: DateRange) =>
    ['campaigns', id, 'heatmap', type, r] as const,
  campaignIosMatchRate: (id: number, r: DateRange) =>
    ['campaigns', id, 'ios-match-rate', r] as const,
  campaignMatchedUsers: (id: number, limit: number, offset: number) =>
    ['campaigns', id, 'matched-users', limit, offset] as const,
  statsOverview: (r: DateRange) => ['stats', 'overview', r] as const,
  tenantTimeline: (r: DateRange) => ['stats', 'timeline', r] as const,
  tenantBreakdown: (dim: BreakdownDim, type: EventType, r: DateRange) =>
    ['stats', 'breakdown', dim, type, r] as const,
  tenantHeatmap: (type: EventType, r: DateRange) =>
    ['stats', 'heatmap', type, r] as const,
};
